module.exports = __webpack_public_path__ + "img/9788949123271.3f658674.jpg";